import { render, staticRenderFns } from "./DealerDetailView.vue?vue&type=template&id=4b521307&scoped=true&"
import script from "./DealerDetailView.vue?vue&type=script&lang=js&"
export * from "./DealerDetailView.vue?vue&type=script&lang=js&"
import style0 from "./DealerDetailView.vue?vue&type=style&index=0&id=4b521307&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b521307",
  null
  
)

export default component.exports